import React from "react";

export const LEAVE_CONFIRM_MESSAGE =
    <p className="modal-title">
        Are you sure you want to leave without saving the changes?
    </p>;
